// A note for one bag line or for the whole bill, edited in place: names what
// it's for, counts characters against the limit, and saves only on Save.
// Esc or Cancel leaves the note as it was; Remove note clears it.
import React, { useState } from "react";

export const NOTE_MAX = 200;

export default function NoteEditor({ title, value, onSave, onClose, bill = false }) {
  const [text, setText] = useState(value || "");
  // Opens with the caret after the note, so typing adds to it.
  const toEnd = (e) => {
    const end = e.target.value.length;
    e.target.setSelectionRange(end, end);
  };
  const save = (e) => {
    e.preventDefault();
    onSave(text.trim());
  };
  return (
    <form
      className={`fp-note-ed${bill ? " fp-billnote" : ""}`}
      onSubmit={save}
      onKeyDown={(e) => {
        if (e.key === "Escape") {
          e.stopPropagation();
          onClose();
        }
      }}
      aria-label={title}
    >
      <label className="fp-lbl" htmlFor="fp-note-text">
        {title}
      </label>
      <textarea id="fp-note-text" autoFocus onFocus={toEnd} rows={2} maxLength={NOTE_MAX} value={text} onChange={(e) => setText(e.target.value)} aria-describedby="fp-note-count" />
      <div className="fp-note-row">
        <span id="fp-note-count" className="fp-note-count fp-muted">
          {text.length}/{NOTE_MAX}
        </span>
        {value && (
          <button type="button" className="fp-btn-ghost fp-btn-sm fp-note-remove" onClick={() => onSave("")}>
            Remove note
          </button>
        )}
        <button type="button" className="fp-btn-ghost fp-btn-sm" onClick={onClose}>
          Cancel
        </button>
        <button type="submit" className="fp-btn-ghost fp-btn-sm" disabled={text.trim() === (value || "").trim()}>
          Save
        </button>
      </div>
    </form>
  );
}
